import React from 'react';

function Pagination({ totalItems, itemsPerPage, currentPage, onPageChange }) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return null;

  const pages = [];
  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, currentPage + 2);

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className="flex items-center justify-center gap-2 p-8 bg-black/10">
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}
        className="p-3 bg-slate-800 text-slate-400 rounded-xl hover:bg-blue-600 hover:text-white transition disabled:opacity-30 disabled:hover:bg-slate-800"
      >
        «
      </button>
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-5 py-3 bg-slate-800 text-slate-400 rounded-xl hover:bg-blue-600 hover:text-white transition disabled:opacity-30 font-black"
      >
        ORQAGA
      </button>

      {startPage > 1 && <span className="text-slate-600 px-2">...</span>}

      {pages.map(p => (
        <button
          key={p}
          onClick={() => onPageChange(p)}
          className={`w-12 h-12 rounded-xl font-black transition ${p === currentPage ? 'bg-blue-600 text-white shadow-[0_0_15px_rgba(37,99,235,0.5)]' : 'bg-slate-800 text-slate-400 hover:bg-slate-700'}`}
        >
          {p}
        </button>
      ))}

      {endPage < totalPages && <span className="text-slate-600 px-2">...</span>}

      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-5 py-3 bg-slate-800 text-slate-400 rounded-xl hover:bg-blue-600 hover:text-white transition disabled:opacity-30 font-black"
      >
        KEYINGI
      </button>
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
        className="p-3 bg-slate-800 text-slate-400 rounded-xl hover:bg-blue-600 hover:text-white transition disabled:opacity-30 disabled:hover:bg-slate-800"
      >
        »
      </button>
    </div>
  );
}

export default Pagination;
